// Uploaded filenames become S3 keys, and those keys become the public asset
// URL that courses-api signs at read time. CloudFront matches a signed URL
// against the path exactly as the browser sends it, so a key containing
// anything the browser rewrites on the wire — or anything that changes how
// the URL parses — produces a signature mismatch and a 403 on content that
// would otherwise load.

// Non-ASCII is deliberately kept: course content is multilingual and
// percent-encoding round-trips it correctly. Only the characters that break
// URL structure are removed.
export function sanitizeFileName(name) {
  return (
    name
      // browsers percent-encode whitespace on the wire
      .replace(/\s+/g, "_")
      // # and ? are URL delimiters; % would look like an existing escape and
      // stop the API encoding the rest of the path; / and \ would inject
      // extra path segments into the key
      .replace(/[#?%/\\]/g, "")
      .replace(/_{2,}/g, "_")
      .replace(/^[._]+|[._]+$/g, "")
  );
}

// Splits a filename into a sanitised base and extension. The extension is
// taken from the last dot so names like "notes.v2.mp4" or "REPORT.PDF"
// survive intact. Falls back to "file" when the base sanitises away entirely
// (e.g. a name made only of stripped characters).
export function splitFileName(name) {
  const lastDotIndex = name.lastIndexOf(".");
  const rawBase = lastDotIndex > 0 ? name.substring(0, lastDotIndex) : name;
  const rawExt = lastDotIndex > 0 ? name.substring(lastDotIndex) : "";
  const ext = sanitizeFileName(rawExt);

  return {
    base: sanitizeFileName(rawBase) || "file",
    ext: ext ? `.${ext}` : "",
  };
}
